import { viewport } from '@placemarkio/geo-viewport'

export interface GeoBounds {
    minLng: number
    minLat: number
    maxLng: number
    maxLat: number
}

export interface CenterZoom {
    longitude: number
    latitude: number
    zoom: number
}

const MIN_ZOOM = 0
const MAX_ZOOM = 20
const TILE_SIZE = 512

export function getElementDimensions(mapWrapper: HTMLDivElement | undefined): [number, number] {
    if (mapWrapper) {
        return [mapWrapper.offsetWidth, mapWrapper.offsetHeight]
    }

    return [0, 0]
}

export function getCenterZoomForBounds(bounds: GeoBounds, dimensions: [number, number]): CenterZoom {
    const wsen: [number, number, number, number] = [bounds.minLng, bounds.minLat, bounds.maxLng, bounds.maxLat]
    const vp = viewport(wsen, dimensions, { minzoom: MIN_ZOOM, maxzoom: MAX_ZOOM, tileSize: TILE_SIZE })

    return {
        longitude: vp.center[0],
        latitude: vp.center[1],
        zoom: vp.zoom,
    }
}
